<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <!-- Progress Indicator -->
                <div class="d-flex justify-content-center mb-4 bulkTopUp-wizard-steps">
                    <div class="wizard-steps">
                        <div class="step" :class="{ active: currentStep === 1, completed: currentStep > 1 }">
                            <div class="step-number">1</div>
                            <div class="step-label">Upload</div>
                        </div>
                        <div class="step-connector" :class="{ active: currentStep > 1 }"></div>
                        <div class="step" :class="{ active: currentStep === 2, completed: currentStep > 2 }">
                            <div class="step-number">2</div>
                            <div class="step-label">Verify</div>
                        </div>
                        <div class="step-connector" :class="{ active: currentStep > 2 }"></div>
                        <div class="step" :class="{ active: currentStep === 3, completed: currentStep > 3 }">
                            <div class="step-number">3</div>
                            <div class="step-label">Finalize</div>
                        </div>
                    </div>
                </div>

                <!-- Alert Messages -->
                <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="showSuccessMessage">
                    {{successMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="showErrorMessage">
                    {{errorMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- Step 1: Upload -->
                <div v-if="currentStep === 1 && !showSuccessMessage && !showErrorMessage">
                    <h6>Step 1: Upload Excel File</h6>
                    <p>Please select an Excel file containing the bulk credit top-up data.</p>
                    
                    <div class="upload-area" @drop="onFileDrop" @dragover="onDragOver" @dragleave="onDragLeave" @dragenter.prevent>
                        <div class="upload-content">
                            <i class="fas fa-upload fa-3x mb-3"></i>
                            <p>Drag and drop your Excel file here</p>
                            <p class="text-muted mb-3">or</p>
                            <input type="file" ref="fileInput" @change="onFileSelect" accept=".xlsx,.xls" style="display: none">
                            <button class="btn btn-primary" @click="$refs.fileInput.click()">Choose File</button>
                        </div>
                    </div>
                    
                    <div v-if="selectedFile" class="mt-3">
                        <p><strong>Selected File:</strong> {{selectedFile.name}}</p>
                        <p><strong>Size:</strong> {{formatFileSize(selectedFile.size)}}</p>
                    </div>
                </div>

                <!-- Step 2: Verify -->
                <div v-if="currentStep === 2 && !showSuccessMessage && !showErrorMessage">
                    <h6>Step 2: Verify Data</h6>
                    <p>Please review the uploaded data before proceeding with the bulk credit top-up.</p>
                    
                    <data-table v-if="bulkCreditsTopUps.length > 0"
                            :headings="verifyDataHeadings"
                            :data="bulkCreditsTopUps"
                            :hasActions="false"
                            :hasNoFilter="true"
                            :hasNoPaging="true">
                    </data-table>
                </div>

                <!-- Step 3: Finalize -->
                <div v-if="currentStep === 3 && !showSuccessMessage && !showErrorMessage">
                    <h6>Step 3: Finalize</h6>
                    <p>Processing completed. Review the results below:</p>
                    
                    <!-- Successful Top-ups -->
                    <div v-if="successfulTopUps.length > 0" class="mb-4">
                        <h6 class="text-success">Successfully Imported ({{successfulTopUps.length}})</h6>
                        <data-table :headings="resultsHeadings"
                                :data="successfulTopUps"
                                :hasActions="false"
                                :hasNoFilter="true"
                                :hasNoPaging="true">
                        </data-table>
                    </div>

                    <!-- Failed Top-ups -->
                    <div v-if="failedTopUps.length > 0">
                        <h6 class="text-danger">Failed to Import ({{failedTopUps.length}})</h6>
                        <data-table :headings="failedResultsHeadings"
                                :data="failedTopUps"
                                :hasActions="false"
                                :hasNoFilter="true"
                                :hasNoPaging="true">
                        </data-table>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <!-- Step 1 Footer -->
                <div v-if="currentStep === 1 && !showSuccessMessage && !showErrorMessage">
                    <button type="button" class="btn btn-primary" @click="uploadFile" :disabled="!selectedFile || loading">
                        <span v-if="loading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                        Next
                    </button>
                    <button type="button" class="btn btn-secondary" :disabled="loading" data-dismiss="modal" @click="onModalCloseClick">Close</button>
                </div>

                <!-- Step 2 Footer -->
                <div v-if="currentStep === 2 && !showSuccessMessage && !showErrorMessage">
                    <button type="button" class="btn btn-success" @click="finalizeTopUp" :disabled="loading">
                        <span v-if="loading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                        Finalize
                    </button>
                    <button type="button" class="btn btn-secondary" @click="goToPreviousStep" :disabled="loading">Back</button>
                    <button type="button" class="btn btn-secondary" :disabled="loading" data-dismiss="modal" @click="onModalCloseClick">Close</button>
                </div>

                <!-- Step 3 Footer -->
                <div v-if="currentStep === 3 && !showSuccessMessage && !showErrorMessage">
                    <button type="button" class="btn btn-primary" @click="onModalCloseClick">Complete</button>
                </div>

                <!-- Error/Success Footer -->
                <div v-if="showSuccessMessage || showErrorMessage">
                    <button type="button" class="btn btn-primary" @click="onModalCloseClick">OK</button>
                </div>
            </div>
        </div>
    </div>
</div>
